import React, { useEffect, useState } from "react";
import { Row, Modal, Icon } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { userProfiles } from "../../redux/slices/UserProfilesSlice";
import { handleRoleNotAllowedRedirection } from "../../utils/userRolesUtils";
import NotAllowed from "../../components/NotAllowed/NotAllowed";
import PreRegistrationForm from "../../components/Forms/PreRegistrationForm/PreRegistrationForm";
import usePreregister from "../../hooks/usePreRegister";
import ActionConfirmationModal from "../../components/Modals/ActionConfirmationModal/ActionConfirmationModal";
import PreRegistrationModal from "../../components/Modals/PreRegistrationModal/PreRegistrationModal";
import useLabels from "../../hooks/useLabels";
import useShipments from "../../hooks/useShipments";
import { resetParticipantsDetails } from "../../redux/slices/ParticipantsDetailsSlice";
import { resetPreRegisterDetails } from "../../redux/slices/PreregisterDetailsSlice";

export default function PreRegistration(props) {
  const userRoles = useSelector(userProfiles);
  const dispatch = useDispatch();
  const isUserAllowed = handleRoleNotAllowedRedirection(userRoles);
  const { handlePreRegisterSteps, preRegistrationDetails } = usePreregister();
  const { getLabels, labelDetails } = useLabels();
  const { searchOptions, getSearchOptions } = useShipments(null);
  const [modalDetails, setGenericModalDetails] = useState({
    isVisible: false,
    type: "",
    serviceType: "",
    isMassive: false,
  });

  const [isColdchainProduct, setIsColdchainProduct] = useState(false);

  useEffect(() => {
    getSearchOptions();
    return () => {
      dispatch(resetParticipantsDetails());
      dispatch(resetPreRegisterDetails());
    };
  }, []);

  const handleModalToggle = () => {
    setGenericModalDetails((prevState) => ({
      ...prevState,
      isVisible: !prevState.isVisible,
    }));
  };

  const handleModalToggleWithRefresh = () => {
    setGenericModalDetails((prevState) => ({
      ...prevState,
      isVisible: !prevState.isVisible,
    }));
    window.location.reload();
  };

  const handlePreRegister = async (preRegisterDetails, setFieldsValue) => {
    setGenericModalDetails((prevState) => ({
      ...prevState,
      isVisible: true,
      serviceType: preRegisterDetails?.serviceType,
      isMassive: preRegisterDetails?.massivePreRegistration,
    }));

    try {
      const preRegister = await handlePreRegisterSteps(
        { ...preRegisterDetails, coldchain: isColdchainProduct },
        setFieldsValue
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleResetForm = async () => {
    console.log("hhh");
  };

  if (!isUserAllowed) {
    return (
      <NotAllowed
        isUserAllowed={isUserAllowed}
        isLoading={userRoles?.isLoading}
      />
    );
  }

  const actions = {
    getLabels: getLabels,
    handleResetForm: handleResetForm,
    handleModalToggle: handleModalToggle,
    handleModalToggleWithRefresh: handleModalToggleWithRefresh,
  };

  return (
    <div className="PreRegistration">
      <h2>Generar envío</h2>
      <Row>
        <PreRegistrationForm
          callback={handlePreRegister}
          preRegistrationDetails={preRegistrationDetails}
          onColdchainChange={setIsColdchainProduct}
          searchOptions={searchOptions.data}
        />
      </Row>
      <Modal
        visible={modalDetails.isVisible}
        onOk={handleModalToggle}
        onCancel={handleModalToggle}
        footer={null}
        width="750px"
        maskClosable={false}
        closable={false}
        destroyOnClose
      >
        {modalDetails.isVisible && (
          <PreRegistrationModal
            preRegisterData={preRegistrationDetails?.data}
            preRegisterErrors={preRegistrationDetails?.errors}
            labelsData={labelDetails?.data}
            labelsErrors={labelDetails?.errors}
            preRegisterisLoading={preRegistrationDetails?.isLoading}
            labelsIsLoading={labelDetails?.isLoading}
            actions={actions}
            serviceType={modalDetails.serviceType}
            isMassive={modalDetails.isMassive}
          />
        )}
      </Modal>
    </div>
  );
}
